/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Toast_Deleted_OneInputs */

const en_toast_deleted_one = /** @type {(inputs: Toast_Deleted_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} moved to the trash`)
};

const de_toast_deleted_one = /** @type {(inputs: Toast_Deleted_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} in den Papierkorb verschoben`)
};

/**
* | output |
* | --- |
* | "{key} moved to the trash" |
*
* @param {Toast_Deleted_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_deleted_one = /** @type {((inputs: Toast_Deleted_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Deleted_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_deleted_one(inputs)
	return en_toast_deleted_one(inputs)
});